<template>
	<div>
		<el-header class="header" :class="NewYear ? 'headerYear' : ''" style="padding: 0 !important; height: 72px !important">
			<Header @nav="changeHeader" :navList="headerList" ref="commonHeader"></Header>
		</el-header>
		<el-container>
			<el-aside class="navbar" style="height: calc(100vh - 72px) !important;overflow: visible;"
				v-show="plant_index != 5">
				<NavBarLeft :list="navList" ref="nav" :icon-type="plant_index"></NavBarLeft>
			</el-aside>
			<el-container class="right-main" style="height: 100% !important">
				<el-main class="main" style="padding: 0 !important" id="mains">
					<keep-alive v-if="!is_local">
						<router-view :key="$route.path + viewKey" @nav="changePage" />
					</keep-alive>
					<router-view :key="$route.path" @nav="changePage" v-else />
				</el-main>
				<el-footer class="footer">
					<nav-tab-bar></nav-tab-bar>
				</el-footer>
			</el-container>
		</el-container>
	</div>
</template>
<script>
import NavBarLeft from "@/components/Navbar.vue";
import Header from "@/components/Header.vue";
import {nav_arr} from '@/utils/nav_list'
// import { newAddress } from "@/api/outwork";
import "@/assets/scss/formstyle.scss";

// plant_type -> id
const typeMapId = {
	1: 2, //协同办公
	2: 3, //企业服务
	3: 1, //客户管理
	4: 5, //文件管理
	5: 6, //消息中心
	6: 7, //组织架构
	7: 8, //系统设置
	// 8: 9, //新人自助,
	10: 10,//工作台
	11: 11,//物业管理
	12: 12,//技术服务
}

export default {
	name: "home",
	data() {
		return {
			is_local:false,
			navList: [],
			xtbg_list:[],
			bhfw_list:[],
			client_list:[],
			file_list:[],
			message_list:[],
			organize_list:[],
			system_list:[],
			newer_list:[],
			work_list:[],
			wuye_list:[],
			technology_list:[],
			headerList: [
				{ name: '工作台', type: 1, id: 10, path: '', show: true },
				{ name: '客户管理', type: 1, id: 1, path: '/custom', show: true },
				{ name: '协同办公', type: 1, id: 2, path: '', show: true },
				{ name: '企业服务', type: 1, id: 3, path: '', show: true },
				{ name: '物业管理', type: 1, id: 11, path: '', show: true },
				// { name: '内容管理', type: 1, id: 4, path: '/tj/douyin', show: true },
				{ name: '技术服务', type: 1, id: 12, path: '', show: true },
				{ name: '文件管理', type: 1, id: 5, path: '', show: true },
				{ name: '消息中心', type: 1, id: 6, path: '', show: true },
				{ name: '组织架构', type: 1, id: 7, path: '', show: true },
				{ name: '系统设置', type: 1, id: 8, path: '', show: true },
				// { name: '新人自助', type: 1, id: 9, path: '/selfservice', show:true  },
				// { name: '新人自助', type: 1, id: 9, path: '/newcomer', show:true  },
			],
			plant_index: 1,
      		NewYear:this.$New_Year,
		};
	},
	components: {
		NavBarLeft,
		Header,
	},
	mounted() {
		this.setNavbar();
		// this.delHouseAddr()
		let system_num = localStorage.getItem('system_index')
		//可能出现system_index 不匹配情况
		let obj = this.$store.getters.allmenulist.find(item => item.path == this.$route.path)
		let headerid = null
		if(obj){
			headerid = typeMapId[obj.plant_type]
		}

		if (!headerid) {
			console.error('未找到对应模块=>',headerid,val);
			// 内容管理
			let arr_data = [];
			nav_arr().list2.forEach((item) => {
				if (item.has_child == 1 && item.page) {
					item.page.forEach((row) => {
						arr_data.push(row.route)
					})
				} else {
					arr_data.push(item.route)
				}
			});

			if (val && arr_data.includes(val)) {
				headerid = 4
			} else {
				headerid = null
			}
		}

		if (headerid && headerid != system_num) {
			system_num = headerid
			this.$refs['commonHeader'].act_nav = headerid
		}
		
		this.changeHeader(system_num)
		this.plant_index = system_num
		this.setHeader()
		const origin = window.location.protocol + "//" + window.location.hostname
		if(origin == 'http://localhost'){
			this.is_local = true   //本地编辑代码后报错不出现白屏
		}
	},
	computed:{
		viewKey :function(){
			if(!this.is_local){
		  		return this.$store.state.viewKey
			}
		}
	},
	watch: {
		'$route.path': function(val, oldVal) {
			if(!this.is_local){
				let obj = this.$store.getters.allmenulist.find(item => item.path == val)
				let headerid = null
				if(obj){
					headerid = typeMapId[obj.plant_type]
				}

				if (!headerid) {
					console.error('未找到对应模块=>',headerid,val);
					//内容管理
					let arr_data = [];
					nav_arr().list2.forEach((item) => {
						if (item.has_child == 1 && item.page) {
							item.page.forEach((row) => {
								arr_data.push(row.route)
							})
						} else {
							arr_data.push(item.route)
						}
					});

					if (arr_data.includes(val)) {
						headerid = 4
					} else {
						headerid = null
						console.error('没查到该路径属于哪个菜单栏', val)
					}
				}

				let belongObj = this.headerList.find(x => x.id == headerid)
				//更新菜单栏
				if (belongObj && headerid != this.plant_index) {
					if (belongObj.type == 1) {
						this.$refs.commonHeader.act_nav = belongObj.id
						this.changeHeader(belongObj.id)
						localStorage.setItem('system_index', belongObj.id)
					}
				}
			}
		}
	},
	methods: {
		setHeader() {
			const reflectObj = {
				'工作台': 'work_list',
				'客户管理': 'client_list',
				'协同办公': 'xtbg_list',
				'企业服务': 'bhfw_list',
				'物业管理': 'wuye_list',
				'文件管理': 'file_list',
				'消息中心': 'message_list',
				'组织架构': 'organize_list',
				'系统设置': 'system_list',
				'技术服务': 'technology_list',
				// '新人自助': 'xx',
			}

			for (let key in reflectObj) {
				let index = this.headerList.findIndex(x => x.name == key)
				if (index > -1) {
					const val_name = reflectObj[key]
					if (this[val_name].length == 0) {
						this.headerList[index].show = false
					} else {
						if(index =='新人自助'){
							break;
						}
						if (this[val_name][0].has_child == 1) {
							this.headerList[index].path = this[val_name][0].page[0].route
						} else {
							this.headerList[index].path = this[val_name][0].route
						}
					}
				}
			}
		},
		changePage(e) {
			this.changeHeader(e)
			this.$refs.commonHeader.changePage(e)
			localStorage.setItem('system_index', e)
			let sys_name = ''
			this.headerList.forEach(item => {
				if (item.id == e) {
					sys_name = item.name
				}
			})
			this.$refs.nav.changePage(sys_name)
		},
		changeHeader(e) {
			if (e == 2) {
				this.navList = this.xtbg_list
			} else if (e == 3) {
				this.navList = this.bhfw_list
			} else if (e == 4) {
				this.navList = nav_arr().list2
			} else if (e == 6) {
				this.navList = this.message_list
			} else if (e == 7) {
				this.navList = this.organize_list
			} else if (e == 8) {
				this.navList = this.system_list
			} else if (e == 1) {
				this.navList = this.client_list
			} else if (e == 10) {
				this.navList = this.work_list
			}else if (e == 11) {
				this.navList = this.wuye_list
			}else if (e == 12) {
				this.navList = this.technology_list
			}else{
				this.navList = []
			}
			// this.navList.forEach(item =>{
			// 	item.path = item.id
			// })
			this.plant_index = e
			let sys_name = ''
			this.headerList.forEach(item => {
				if (item.id == e) {
					sys_name = item.name
				}
			})
			this.$refs.nav.changePage(sys_name)
		},
		setNavbar() {
			let array = this.$store.state.userpower
			this.navList = array
			this.xtbg_list = []
			for (var a = 0; a < this.navList.length; a++) {
				let item = this.navList[a]
				item.path = item.route ? item.route : item.name + a
				if (item.has_child == 1) {
					for (var b = 0; b < item.length; b++) {
						item.page[b].path = item.page[b].route
					}
				}
				if(item.plant_type == 1){
					this.xtbg_list.push(item)
				}
				if (item.plant_type == 2) {
					this.bhfw_list.push(item)
				}
				if (item.plant_type == 3) {
					this.client_list.push(item)
				}
				if (item.plant_type == 4) {
					this.file_list.push(item)
				}
				if (item.plant_type == 5) {
					this.message_list.push(item)
				}
				if (item.plant_type == 6) {
					this.organize_list.push(item)
				}
				if (item.plant_type == 7) {
					this.system_list.push(item)
				}
				if (item.plant_type == 8) {
					this.newer_list.push(item)
				}
				if (item.plant_type == 10) {
					this.work_list.push(item)
				}
				if (item.plant_type == 11) {
					this.wuye_list.push(item)
				}
				if (item.plant_type == 12) {
					this.technology_list.push(item)
				}
			}
			// this.navList = [];
		},
		// delHouseAddr(){
		// 	let tempaddr = localStorage.getItem('tempaddr')
		// 	if (tempaddr) {
		// 		let obj = JSON.parse(tempaddr)
		// 		obj.handel = 2
		// 		newAddress(obj).then(res => {
		// 			if (res.code == 200) {
		// 				if (res.data) {
		// 					localStorage.removeItem('tempaddr')
		// 				}
		// 			} else {
		// 				this.$message.error(res.msg)
		// 			}
		// 		})
		// 	}
		// }
	},
};
</script>

<style lang="scss" scoped>
:deep(.el-main) {
	height: calc(100vh - 72px - 40px); //181px为顶部header高度+底部footer高度
	overflow-y: auto;
}

:deep(.el-footer.footer) {
	height: 40px !important;
	padding: 0 !important;
}
</style>

<style lang="scss">
.navbar {
	height: calc(100vh - 72px) !important;
	width: auto !important;

	.el-menu-vertical-demo:not(.el-menu--collapse) {
		// width: 80px;
		width: 220px;

	}

	.el-menu--collapse {
		width: auto !important;
	}

	.right-main {
		width: calc(1920px - 220px);

		.el-header {
			padding: 0 20px;
		}

		.header {
			height: 60px;
			box-sizing: border-box;
			padding: 0 !important;
		}


		.main {
			padding: 0 !important;
			height: calc(100% - 72px) !important;
		}
	}

	.el-aside {
		transition: width 0.15s;
		-webkit-transition: width 0.15s;
		-moz-transition: width 0.15s;
		-webkit-transition: width 0.15s;
		-o-transition: width 0.15s;
	}

	.is-opened {
		display: block;
		background: white !important;
	}
}

.el-aside::-webkit-scrollbar {
	display: none;
}
</style>
<style lang="scss" scoped>
.headerYear {
	//background-image: url("@/assets/image/newyear/headerbg.png");
	//background-size: 100% 100%;
	//background-repeat: no-repeat;
}
</style>
